<template>
  <div class="Topnav lxn-margin-auto">
    <div v-if="!centerText && (rightText || rightIcon)" class="TopNav-wrapper-title-right lxn-h100 lxn-float-right" :class="titleWidthClass">
      <div @click="$emit('rightTextClick')" v-if="rightIcon" v-html="svgIconRight" class="lxn-float-right lxn-h100 TopNav-icon lxn-cursor-pointer"></div>
      <div @click="$emit('rightTextClick')" v-if="rightText" :class="$store.getters.language.font" class="lxn-title TopNav-title lxn-lineH-50px lxn-h100 lxn-float-right lxn-overflow-hidden lxn-cursor-pointer">
          {{rightText}}
      </div>
    </div>
    <div v-if="!centerText && (leftText || leftIcon)" class="TopNav-wrapper-title-left lxn-h100 lxn-float-left" :class="titleWidthClass">
      <div @click="$emit('leftTextClick')" v-if="leftIcon" v-html="svgIconLeft" class="lxn-float-left lxn-h100 TopNav-icon lxn-cursor-pointer"></div>
      <div @click="$emit('leftTextClick')" v-if="leftText" :class="$store.getters.language.font" class="lxn-title TopNav-title lxn-lineH-50px lxn-h100 lxn-float-left lxn-overflow-hidden lxn-cursor-pointer">
          {{leftText}}
      </div>
    </div>
    <div v-if="centerText" :class="$store.getters.language.font" class="lxn-title TopNav-title-center lxn-lineH-50px lxn-text-center lxn-h100 lxn-w100 lxn-overflow-hidden lxn-cursor-pointer">
      {{centerText}}
    </div>
  </div>
</template>

<script>
import svgIcons from '@/statics/svgIcons.js'

export default {
  name: 'TopNav',
  props: {
    leftText: String,
    leftIcon: String,
    rightText: String,
    rightIcon: String,
    centerText: String
  },
  data: function () {
    return {
    }
  },
  computed: {
    titleWidthClass: function(){
      return ((this.leftText || this.leftIcon) && (this.rightText || this.rightIcon))? 'half' : 'lxn-w100';
    },
    svgIconLeft: function() {
      return svgIcons[this.leftIcon];
    },
    svgIconRight: function() {
      return svgIcons[this.rightIcon];
    },
  }
}
</script>

<style>
  .Topnav {
    width: calc(100% - 36px);
    height: 50px;
  }
  .TopNav-wrapper-title-right.half {
    width: 50%;
  }
  .TopNav-wrapper-title-left.half {
    width: 50%;
  }
  .TopNav-title {
    max-width: calc(100% - 34px);
    color: #ffffff;
    margin-right: 5px;
    margin-left: 5px;
  }
  .TopNav-title-center {
    color: #ffffff;
  }
  .TopNav-icon {
    width: 20px;
    height: 20px;
    margin-top: calc(25px - 10px);
  }
  .TopNav-icon {
    fill: #ffffff;
  }
</style>
